//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TabelaGenerica from '../../../../shared-components/generico/TabelaGenerica';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  extends: TabelaGenerica,
  props: {
    isExportAvailable: {
      type: Boolean,
      default: true,
    },
    isSearchAvailable: {
      type: Boolean,
      default: true,
    },
    isPaginationAvailable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...generateComputed('Sellin', [
      'canImport',
      'canExport',
    ]),
    isContentAvailable() {
      return !!this.tableData && !!this.tableData.length;
    },
    filteredList() {
      return [];
    },
  },
  watch: {
    searchQuery() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filterDatasource();
      }, 500);
    },
  },
  methods: {
    filterDatasource() {
      this.$emit('SELLINTABELADETALHADO_BUSCA', this.searchQuery);
    },
    formatCurrency(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
    formatDecimal(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'decimal' });
    },
    formatPercent(val) {
      return ((val / 100) || 0).toLocaleString('pt-br', { style: 'percent' });
    },
    retornarSellInConsolidado() {
      this.$emit('SELLINTABELACONSOLIDADO_EXIBIR');
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/sell-in/SellinTabelaDetalhado.vue?vue&type=script&lang=js&